import { combineReducers } from 'redux'

import user from './user'
import auth from './auth'
import owners from './owners'
import owner from './owner'
import products from './products'
import product from './product'
import newsList from './newsList'
import news from './news'
import account from './account'
import title from './title'
import categories from './categoryBoard'
import boards from './boards'
import board from './board'

export default combineReducers({
    user,
    auth,
    owner,
    owners,
    products,
    product,
    newsList,
    news,
    account,
    title,
    categories,
    boards,
    board
})